import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  elementColours,
  fluidFontSize,
  fontSize,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Button, HtmlContent } from './ui';

//moved up for selection
const StyledImage = styled.img`
  max-width: 320px;
  max-height: 270px;
  width: 100%;
  height: 100%;

  ${minBreakpointQuery.smedium`
    grid-row-start: 1;
  `}
`;

const StyledFeaturedStep = styled.li`
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 20px;

  ${minBreakpointQuery.smedium`
    position: relative;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  `}

  ${minBreakpointQuery.medium`
    gap: 60px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 100px;
  `}

  ${minBreakpointQuery.large`
    gap: 150px;
  `}

  ${minBreakpointQuery.xlarge`
    gap: 210px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 280px;
  `}

  &:nth-child(odd) {
    ${StyledImage} {
      ${minBreakpointQuery.smedium`
        grid-column-start: 2;
      `}
    }
  }

  &:not(:last-child) {
    &:before {
      ${minBreakpointQuery.smedium`
        content: '';
        position: absolute;
        bottom: -30px;
        left: 0;
        display: block;
        height: 1px;
        width: 50%;
        border-bottom: 1px dashed ${brandColours.secondary};
      `}
    }

    &:nth-child(odd) {
      &:before {
        ${minBreakpointQuery.smedium`
          transform: translateX(50%) rotate(35deg);
        `}
      }
    }

    &:nth-child(even) {
      &:before {
        ${minBreakpointQuery.smedium`
          transform: translateX(50%) rotate(-35deg);
        `}
      }
    }
  }
`;

const StyledContent = styled.div`
  position: relative;
  padding: 30px;
  background-color: ${standardColours.white};
  border-radius: 40px;
  counter-increment: steps-counter;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px;
  `}

  &:before {
    content: counter(steps-counter);
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    height: 70px;
    width: 70px;
    ${fluidFontSize(
      '25px',
      '40px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};
    background-color: ${brandColours.tertiary};
    border-radius: 50%;
    transform: translate(25%, -25%);

    ${minBreakpointQuery.small`
      padding: 15px;
      height: 85px;
      width: 85px;
    `}

    ${minBreakpointQuery.large`
      padding: 20px;
      height: 100px;
      width: 100px;
    `}
  }
`;

const StyledHeading = styled.h3`
  color: ${brandColours.secondary};
  ${fontSize(21)};

  ${minBreakpointQuery.small`
    ${fontSize(23)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `}
`;

const StyledText = styled(HtmlContent)`
  margin-top: 16px;
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
  color: ${elementColours.textColour};
  background-color: ${standardColours.white};
  border: 2px solid ${brandColours.secondary};
`;

const FeaturedStep = ({ image, heading, content, link }) => (
  <StyledFeaturedStep>
    <StyledImage src={image.url} alt={image.alt} loading="lazy" />
    <StyledContent>
      <StyledHeading>{heading}</StyledHeading>
      <StyledText content={content} />
      {link && <StyledButton to={link.pageUrl}>{link.text}</StyledButton>}
    </StyledContent>
  </StyledFeaturedStep>
);

export default FeaturedStep;
